var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.uppyId}},[(_vm.collection === 'thumbnail')?_c('div',{staticClass:"ThumbnailContainer"},[_c('button',{staticClass:"button",attrs:{"id":"open-thumbnail-modal"}},[_vm._v("Select file")])]):_c('div',{staticClass:"DashboardContainer",staticStyle:{"padding":"0 1rem"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }